module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_PU SKIN_deskstop.e4377c94.jpg";